import React from 'react';

import { PrismicRichText } from '@prismicio/react';
import InfoThickIcon from '@repo/ui/components/Icon/InfoThickIcon';
import { themeStyle } from '@repo/ui/theming';

import { Box, FlipIcon } from './styles';

const InfoBox = ({ slice }) => {
  return (
    <Box>
      <FlipIcon>
        <InfoThickIcon height="20px" theme={{ color: themeStyle.varInkMain }} />
      </FlipIcon>

      <PrismicRichText field={slice.primary.description} />
    </Box>
  );
};

export default InfoBox;
